module.exports = __webpack_public_path__ + "static/img/iconmenu04.d3701dac.svg";